module.exports = __webpack_public_path__ + "img/employment.e252082d.svg";